import React from 'react';
import { CustomButton, CustomImage, Text } from './index';
import { useHistory } from 'react-router-dom';
import help from '@src/assets/icons/icon-profil-yardim.svg';
import arrowLeft from '@src/assets/icons/icon-profil-arrow-left.svg';
import '@src/styles/components/pageHeader.scss';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const CustomPageHeader = ({
  children,
  routes = [],
  title,
  showBreadCrumb,
  showHelpButton,
  showOthersButton,
  adminCustomHeaderContent,
  ...props
}) => {
  const history = useHistory();
  const { isAdmin } = useSelector((state) => state?.auth);

  return (
    <>
      <div className={`custom-header-content ${adminCustomHeaderContent}`} {...props}>
        <div className=" action-buttons">
          <h2 className="custom-title-text">
            <CustomImage onClick={() => history.goBack()} src={arrowLeft} />
            {title}
          </h2>
          <div>
            {showOthersButton}
            {/* showHelpButton && (
              <CustomButton className="custom-btn-success">
                <CustomImage src={help} />{' '}
                <span>
                  <Text t="help" />
                </span>
              </CustomButton>
            )*/}
          </div>
        </div>
        {showBreadCrumb && (
          <div className="row custom-breadcrumb">
            <span className="page-title">
              <Text t="homePage" />
            </span>
            <span className="icon-slash">/</span>
            {routes.length > 0 && (
              <>
                {!isAdmin &&
                  routes.map((route) => (
                    <React.Fragment key={route}>
                      <span className="page-title">
                        <Text t={route} />
                      </span>
                      <span className="icon-slash">/</span>
                    </React.Fragment>
                  ))}
              </>
            )}
            <span className="current-page-title">{title}</span>
          </div>
        )}
      </div>
      {children}
    </>
  );
};

CustomPageHeader.propTypes = {
  children: PropTypes.any,
  routes: PropTypes.any,
  title: PropTypes.object,
  showBreadCrumb: PropTypes.bool,
  showHelpButton: PropTypes.bool,
  showOthersButton: PropTypes.bool,
  adminCustomHeaderContent: PropTypes.string,
};

export default CustomPageHeader;
